import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import setQuery from 'set-query-string'
import moment from 'moment'
import store from 'store2'
import { showLoader } from '../../../../../actions/main-actions'
import { roundPrice, parseQuery } from '../../../../../utils'
import { convertCurrency } from '../../../../helpers'
import { pushToDataLayer, trackGA4Ecommerce } from '../../../../../gtm'
import { formatDate } from '../../../../helpers/DateFormat'
import useGTM from '../../../hooks/useGTM'

export default function useCheckoutEffects({
  shopInfo,
  checkoutInclusions,
  selectedTrip,
  guestsSplitting,
  totalPrice,
  dueNowData,
  getDueNowData,
  roomParams,
  tripId,
}) {
  const dispatch = useDispatch()
  const { setGtmDataForInclusions } = useGTM()

  useEffect(() => {
    dispatch(showLoader(false))
  }, [])

  useEffect(() => {
    const query = parseQuery() || {}
    if(shopInfo && checkoutInclusions && selectedTrip && guestsSplitting) {
      setQuery(null)
      const cabinPrices = guestsSplitting.reduce((acc, item) => {
        item.pricing.forEach((pricing) => {
          acc.push({
            ...pricing,
            pricing: pricing.id,
            quantity: pricing.qty,
            isRoom: true,
          })
        })
        return acc
      }, [])
      const queryParams = {
        dateFrom: formatDate(selectedTrip.dateFrom, 'YYYY-MM-DD'),
        dateTo: formatDate(selectedTrip.dateTo, 'YYYY-MM-DD'),
        productId: tripId,
        savedOrder: true,
        ...query,
      }
      const cabinPricing = []
      guestsSplitting.forEach((cabins) => {
        const splitted = []
        cabins.cart.forEach((cart) => {
          const items = []
          cart.forEach((cartItem) => {
            items.push({ id: cartItem.id, qty: cartItem.qty })
          })
          splitted.push(items)
        })
        cabinPricing.push(splitted)
      })
      queryParams.cabinPricing = JSON.stringify(cabinPricing)
      checkoutInclusions.forEach((item) => {
        if(item.diverNumber) {
          queryParams[`incl_${item.pricing}_${item.diverNumber - 1}_${item.guestType}`] = item.quantity
        } else if(item.divingItem) {
          queryParams[`diving_${item.pricing}_${item.key}_${item.numberOfInstances}`] = item.quantity
        } else if(!item.isRoom) {
          queryParams[`incl_${item.pricing}`] = item.quantity
        }
      })
      setQuery(queryParams, { clear: true })
      getDueNowData(shopInfo.id, [...checkoutInclusions, ...cabinPrices], {
        ...selectedTrip,
        roomParams,
        isConfirmed: true,
      })

      const convertedPrice = roundPrice(convertCurrency(totalPrice, shopInfo.currency, 'USD'))
      pushToDataLayer({
        checkout_order_amount: convertedPrice,
        checkout_cart_value: convertedPrice,
      })

      const { GA4Products } = setGtmDataForInclusions(checkoutInclusions)
      guestsSplitting.forEach((cabin) => {
        cabin.pricing.forEach((pricing) => {
          GA4Products.push({
            item_id: pricing.id.toString(),
            price: Number(roundPrice(convertCurrency(pricing.priceNet, shopInfo.currency, 'USD'))),
            item_variant: `${selectedTrip.itinerary.title} / ${cabin.titlte} / ${moment(pricing.dateFrom).utc().locale('en').format('DD MMM')}-${moment(pricing.dateTo).utc().locale('en').format('DD MMM')} / ${pricing.isDiver ? `${pricing.qty} diver(s)` : `${pricing.qty} non-diver(s)`}`,
            item_brand: 'PADI',
            item_name: shopInfo.title,
            item_category: 'PADI Travel',
            item_category2: 'Liveaboard',
            item_list_name: 'PADI Travel Liveaboard - Product Page',
            quantity: pricing.qty,
          })
        })
      })
      if(dueNowData?.taxFreeAmount) {
        trackGA4Ecommerce('begin_checkout', {
          currency: 'USD',
          value: Number(convertCurrency(dueNowData?.taxFreeAmount, dueNowData?.currency, 'USD').toFixed(2)),
          items: GA4Products,
        }, 'PADI Travel - Liveaboards')
      }
      store.session.set('ecommerce', GA4Products)
    }
  }, [shopInfo, checkoutInclusions, guestsSplitting, selectedTrip, totalPrice, dueNowData?.taxFreeAmount])
}
